(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    function destaniyaPriceSliderInit(scope) {
      var root = scope || document;
      var components = root.querySelectorAll('price-facet-component');
      components.forEach(function (comp) {
        if (comp.dataset.dualSliderInit === 'true') return;
        comp.dataset.dualSliderInit = 'true';

        var slider = comp.querySelector('.price-slider');
        var minSlider = comp.querySelector('.price-slider__input--min');
        var maxSlider = comp.querySelector('.price-slider__input--max');
        var fill = comp.querySelector('.price-slider__fill');
        var minLabel = comp.querySelector('[data-min-label]');
        var maxLabel = comp.querySelector('[data-max-label]');
        var minInput = comp.querySelector('input[ref="minInput"]');
        var maxInput = comp.querySelector('input[ref="maxInput"]');
        if (!slider || !minSlider || !maxSlider || !minInput || !maxInput) return;

        var rangeMax = parseFloat(slider.getAttribute('data-range-max')) || parseFloat(minSlider.max) || 0;
        var symbol = comp.getAttribute('data-currency-symbol') || '$';

        function fmt(n) { return symbol + Math.round(n); }

        function readValues() {
          var minV = parseFloat(minSlider.value);
          var maxV = parseFloat(maxSlider.value);
          if (minV > maxV) { var t = minV; minV = maxV; maxV = t; }
          return { minV: minV, maxV: maxV };
        }

        function paint() {
          if (!rangeMax) return;
          var v = readValues();
          var leftPct = (v.minV / rangeMax) * 100;
          var rightPct = (v.maxV / rangeMax) * 100;
          fill.style.left = leftPct + '%';
          fill.style.right = (100 - rightPct) + '%';
          minLabel.textContent = fmt(v.minV);
          maxLabel.textContent = fmt(v.maxV);
        }

        function syncToInputs(triggerChange) {
          var v = readValues();
          // Reset slider DOM values in case of swap
          minSlider.value = v.minV;
          maxSlider.value = v.maxV;
          minInput.value = v.minV > 0 ? v.minV : '';
          maxInput.value = v.maxV < rangeMax ? v.maxV : '';
          paint();
          if (triggerChange) {
            minInput.dispatchEvent(new Event('change', { bubbles: true }));
            maxInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        minSlider.addEventListener('input', function () { paint(); });
        maxSlider.addEventListener('input', function () { paint(); });
        minSlider.addEventListener('change', function () { syncToInputs(true); });
        maxSlider.addEventListener('change', function () { syncToInputs(true); });

        // Smart thumb selection: when thumbs overlap, the user might want to drag whichever is closer
        slider.addEventListener('pointerdown', function (e) {
          var rect = slider.querySelector('.price-slider__track-wrap').getBoundingClientRect();
          var pct = (e.clientX - rect.left) / rect.width;
          var clickedVal = pct * rangeMax;
          var v = readValues();
          var distToMin = Math.abs(clickedVal - v.minV);
          var distToMax = Math.abs(clickedVal - v.maxV);
          if (distToMin < distToMax) {
            minSlider.style.zIndex = 3;
            maxSlider.style.zIndex = 2;
          } else {
            minSlider.style.zIndex = 2;
            maxSlider.style.zIndex = 3;
          }
        });

        paint();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { destaniyaPriceSliderInit(); });
    } else {
      destaniyaPriceSliderInit();
    }
    document.addEventListener('shopify:section:load', function (e) { destaniyaPriceSliderInit(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-unified-content"] && !Shopify.designMode) return;
  try {
    function scrollToDirection(media, direction) {
    const scroller = media.querySelector('.comp-products__scroller');
    const slide = scroller && scroller.querySelector('.comp-products__img');
    if (!scroller || !slide) return;

    const slideWidth = slide.getBoundingClientRect().width;
    if (!slideWidth) return;

    const slideCount = Math.round(scroller.scrollWidth / slideWidth);
    const currentIndex = Math.round(scroller.scrollLeft / slideWidth);
    let nextIndex = currentIndex + direction;
    if (nextIndex < 0) nextIndex = slideCount - 1;
    if (nextIndex >= slideCount) nextIndex = 0;

    scroller.scrollTo({ left: nextIndex * slideWidth, behavior: 'smooth' });
  }

  function setMediaImages(media, imagesCsv) {
    media.dataset.images = imagesCsv || '';
    const images = (imagesCsv || '').split(',').filter(Boolean);

    const scroller = media.querySelector('.comp-products__scroller');
    if (scroller) {
      scroller.innerHTML = images.map((url) => `<img class="comp-products__img" src="${url}" alt="" loading="lazy">`).join('');
      scroller.scrollTo({ left: 0, behavior: 'instant' });
    }

    const prevBtn = media.querySelector('.comp-products__gallery-nav--prev');
    const nextBtn = media.querySelector('.comp-products__gallery-nav--next');
    const hasMultiple = images.length > 1;
    if (prevBtn) prevBtn.hidden = !hasMultiple;
    if (nextBtn) nextBtn.hidden = !hasMultiple;
  }

  document.addEventListener('click', (e) => {
    const navBtn = e.target.closest('.comp-products__gallery-nav');
    if (navBtn) {
      const media = navBtn.closest('.comp-products__media');
      if (!media) return;
      const direction = navBtn.classList.contains('comp-products__gallery-nav--next') ? 1 : -1;
      scrollToDirection(media, direction);
      return;
    }

    const swatch = e.target.closest('.comp-products__swatch');
    if (!swatch) return;

    const card = swatch.closest('.comp-products__card');
    if (!card) return;

    // The click-through link lives either on our own media-link (standalone card)
    // or on a sibling ref="productCardLink" anchor provided by the surrounding
    // <product-card> wrapper (collection grid block context) — update both.
    const productCardEl = swatch.closest('product-card');
    const outerCardLink = productCardEl ? productCardEl.querySelector('[ref="productCardLink"]') : null;

    const media = card.querySelector('.comp-products__media');
    const titleEl = card.querySelector('.comp-products__title');
    const subtitleEl = card.querySelector('.comp-products__subtitle');
    const priceEl = card.querySelector('.comp-products__price');
    const cardLink = card.querySelector('.comp-products__media-link');
    const quickAddVariantInput = card.querySelector('.quick-add input[name="id"]');

    if (media) {
      setMediaImages(media, swatch.dataset.productImages);
    }
    if (titleEl) {
      titleEl.textContent = swatch.dataset.productTitle;
      titleEl.href = swatch.dataset.productUrl;
    }
    if (subtitleEl) {
      subtitleEl.textContent = swatch.dataset.productSubtitle;
    }
    if (priceEl) {
      const comparePrice = swatch.dataset.productComparePrice;
      priceEl.innerHTML = comparePrice ? '<span class="comp-products__price-current"></span><s class="comp-products__price-compare"></s>' : '<span class="comp-products__price-current"></span>';
      if (comparePrice) {
        priceEl.querySelector('.comp-products__price-compare').textContent = comparePrice;
      }
      priceEl.querySelector('.comp-products__price-current').textContent = swatch.dataset.productPrice;
    }
    if (cardLink) {
      cardLink.href = swatch.dataset.productUrl;
    }
    if (outerCardLink && outerCardLink !== cardLink) {
      outerCardLink.href = swatch.dataset.productUrl;
    }
    if (quickAddVariantInput) {
      quickAddVariantInput.value = swatch.dataset.productVariant;
    }

    card.querySelectorAll('.comp-products__swatch').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
  });
  } catch(e) { console.error(e); }
})();

})();
